/**
 * The sign-in card's three sizes, in one place — Simo's 2026-09-09 size pass
 * (Figma "UX/UI WebApp" `pKO9bydKQ3f8mJgggb6Idv`, frame 30000:39413) touched
 * every call site on both platforms because each one spelled its own size.
 * The blocks cannot enforce these (the buttons and fields arrive as slots),
 * so both platforms READ them instead of re-typing them.
 */

/**
 * Ka's tile, in DS points at scale 1 — a 56px square. Radius, ring width and
 * how the art is framed all DERIVE from this via `professorKaTileMetrics`.
 */
export const SIGN_IN_KA_TILE_SIZE = 56;

/** Every button on the card — social, Continue, the code steps' CTA: DS `xl` (48px). */
export const SIGN_IN_ACTION_SIZE = 'xl' as const;

/** Every text field on the card — email, password, new password: DS `l` (44px). */
export const SIGN_IN_FIELD_SIZE = 'l' as const;
